import getLocalString from "constants/Localization";
import { useDeleteDailyFormVehicleMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteDailyFormVehicle() {
  const [mutation, { loading, data, error }] = useDeleteDailyFormVehicleMutation({
    refetchQueries: ["getDailyFormVehicles"],
  });

  const [deleteDailyFormVehicle, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteDailyFormVehicle",
    },
    {
      successMessage: getLocalString("fleet.delete-vehicle-success"),
      failureMessage: getLocalString("fleet.delete-vehicle-failure"),
    }
  );

  return [deleteDailyFormVehicle, context] as const;
}
